import { formatNumber } from '../../utils/format';

export interface InsufficientDataProps {
  threshold: number;
  actual: number;
}

export function InsufficientData({ threshold, actual }: InsufficientDataProps) {
  return (
    <div className="honesty-insufficient">
      מידע חסר — נדרשים לפחות {formatNumber(threshold)} אירועים (יש {formatNumber(actual)}).
    </div>
  );
}
